// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    // Table headers
    name: "Name",
    riskModel: "Risk Model",
    portfolios: "Portfolios",
    active: "Active",
    actions: "Actions",
    // Actions
    addPortfolioCollection: "Add Portfolio Collection",
    // Messages
    none: "None",
    portfolio: "portfolio",
    portfoliosPlural: "portfolios",
    noCollections: 'No portfolio collections yet. Click "Add Portfolio Collection" to create one.',
    // Alerts
    error: "Error",
    collectionDeletedSuccess: "Portfolio collection deleted successfully",
    failedToDeleteCollection: "Failed to delete collection",
    failedToToggleActive: "Failed to update active state",
    // Confirm dialog
    deleteCollection: "Delete Portfolio Collection",
    deleteCollectionDescription:
      "Are you sure you want to delete this portfolio collection? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
  },
  nb_NO: {
    edit: "Rediger",
    // Table headers
    name: "Navn",
    riskModel: "Risikomodell",
    portfolios: "Porteføljer",
    active: "Aktiv",
    actions: "Handlinger",
    // Actions
    addPortfolioCollection: "Legg til porteføljesamling",
    // Messages
    none: "Ingen",
    portfolio: "portefølje",
    portfoliosPlural: "porteføljer",
    noCollections:
      'Ingen porteføljesamlinger ennå. Klikk "Legg til porteføljesamling" for å opprette en.',
    // Alerts
    error: "Feil",
    collectionDeletedSuccess: "Porteføljesamling slettet",
    failedToDeleteCollection: "Kunne ikke slette samling",
    failedToToggleActive: "Kunne ikke oppdatere aktiv-status",
    // Confirm dialog
    deleteCollection: "Slett porteføljesamling",
    deleteCollectionDescription:
      "Er du sikker på at du vil slette denne porteføljesamlingen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
  },
} as const;
